define('common/ko/extension/fallback',['module', 'underscore', 'knockout'], function(module, _, ko) {
    ko.extenders.fallback = function(target, conf) {
        target.$$fallbackConfiguration = conf;
        return target;
    };
});

